(() => {
  document.querySelectorAll('.fcg-habits-scroll').forEach(view => {
    if (view.dataset.animated) return;
    view.dataset.animated = 'true';
    view.setAttribute('aria-label', 'Things parents try');
    const list = view.querySelector('.fcg-habits');
    const track = document.createElement('div');
    track.className = 'fcg-habits-track';
    list.before(track);
    track.append(list);
    const copy = list.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.inert = true;
    copy.classList.add('fcg-habits-copy');
    track.append(copy);
    const size = () => {
      const height = list.getBoundingClientRect().height;
      track.style.setProperty('--fcg-travel', `-${height}px`);
      track.style.setProperty('--fcg-duration', `${height / 16}s`);
    };
    new ResizeObserver(size).observe(list);
    size();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fcg-motion-toggle';
    button.textContent = 'Pause animation';
    button.setAttribute('aria-pressed', 'false');
    button.addEventListener('click', () => {
      const paused = view.classList.toggle('is-paused');
      button.textContent = paused ? 'Play animation' : 'Pause animation';
      button.setAttribute('aria-pressed', String(paused));
    });
    view.after(button);
  });
})();
